// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3b3xa","actions":"GroupTable_actions__3_lD6","deleteModalFooter":"GroupTable_deleteModalFooter__2A3PV"};